module.exports = __webpack_public_path__ + "img/brand-cases3.82696bfb.png";